import moment from 'moment';
export const convertModelToFormData = (data, form = new FormData(), namespace = '') => {
    let files = {};
    let model = {};
    for (let propertyName in data) {
        if (!data.hasOwnProperty(propertyName) || !data[propertyName])
            continue;
        if (data[propertyName] instanceof Array) {
            if (data[propertyName].every((x) => x instanceof File)) {
                files[propertyName] = data[propertyName];
            }
            else {
                model[propertyName] = data[propertyName];
            }
        }
        else if (data[propertyName] instanceof File || data[propertyName]) {
            files[propertyName] = data[propertyName];
        }
        else {
            model[propertyName] = data[propertyName];
        }
    }
    let formData = form || new FormData();
    for (let propertyName in model) {
        if (!model.hasOwnProperty(propertyName) || !model[propertyName])
            continue;
        let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
        if (model[propertyName] instanceof Date)
            formData.append(formKey, model[propertyName].toISOString());
        else if (model[propertyName] instanceof File) {
            formData.append(formKey, model[propertyName]);
        }
        else if (model[propertyName] instanceof Array) {
            model[propertyName].forEach((element, index) => {
                const tempFormKey = `${formKey}[${index}]`;
                if (typeof element === 'object')
                    convertModelToFormData(element, formData, tempFormKey);
                else
                    formData.append(tempFormKey, element.toString());
            });
        }
        else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
            convertModelToFormData(model[propertyName], formData, formKey);
        else {
            formData.append(formKey, model[propertyName].toString());
        }
    }
    for (let propertyName in files) {
        if (files.hasOwnProperty(propertyName)) {
            if (files[propertyName] instanceof Array) {
                files[propertyName].forEach((element) => {
                    formData.append(propertyName, element);
                });
            }
            else
                formData.append(propertyName, files[propertyName]);
        }
    }
    return formData;
};
export const convertModelToFormDataForNestedFiles = (data, form = new FormData(), namespace = '') => {
    let files = {};
    let model = {};
    for (let propertyName in data) {
        if (!data.hasOwnProperty(propertyName) || !data[propertyName])
            continue;
        if (data[propertyName] instanceof Array) {
            if (data[propertyName].every((x) => x instanceof File)) {
                files[propertyName] = data[propertyName];
            }
            else {
                model[propertyName] = data[propertyName];
            }
        }
        else if (data[propertyName] instanceof File) {
            files[propertyName] = data[propertyName];
        }
        else {
            model[propertyName] = data[propertyName];
        }
    }
    let formData = form || new FormData();
    for (let propertyName in model) {
        if (!model.hasOwnProperty(propertyName) || !model[propertyName])
            continue;
        let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
        if (model[propertyName] instanceof Date) {
            formData.append(formKey, model[propertyName].toISOString());
        }
        else if (model[propertyName] instanceof Array) {
            model[propertyName].forEach((element, index) => {
                const tempFormKey = `${formKey}[${index}]`;
                if (typeof element === 'object') {
                    // Handle nested objects
                    convertModelToFormData(element, formData, tempFormKey);
                }
                else {
                    formData.append(tempFormKey, element.toString());
                }
            });
        }
        else if (typeof model[propertyName] === 'object') {
            convertModelToFormData(model[propertyName], formData, formKey);
        }
        else {
            formData.append(formKey, model[propertyName].toString());
        }
    }
    for (let propertyName in files) {
        if (files.hasOwnProperty(propertyName)) {
            if (files[propertyName] instanceof Array) {
                files[propertyName].forEach((element) => {
                    formData.append(propertyName, element);
                });
            }
            else {
                formData.append(propertyName, files[propertyName]);
            }
        }
    }
    // Handle specific case for 'file nesting'
    if (data.otherDocuments && Array.isArray(data.otherDocuments)) {
        data.otherDocuments.forEach((doc, index) => {
            if (doc.fileData instanceof File) {
                formData.append(`otherDocuments[${index}].fileData`, doc.fileData);
            }
            // You can append other properties of doc as needed
            formData.append(`otherDocuments[${index}].type`, doc.type);
            formData.append(`otherDocuments[${index}].size`, doc.size);
        });
    }
    return formData;
};
export const convertDateTime = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('YYYY-MM-DD');
    return '';
};
export const formatDMY = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('DD-MM-YYYY');
    return '';
};
export const formatDateDMY = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('DD-MM-YYYY');
    return '';
};
export const formatDateMonthDayYear = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('MMM, DD YYYY');
    return '';
};
export const formatDateDayMonthYear = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('DD MMM YYYY');
    return '';
};
export const formatDateDayMonthYearUsingGB = (date) => {
    if (date !== null && date !== undefined)
        return moment(date, 'DD-MM-YYYY').format('D MMM YYYY');
    return '';
};
// Formats a date as "D MMM YYYY" (e.g. "4 May 2026", "23 Sep 2025") — display only, never mutates the original value.
export const formatDisplayDate = (date) => {
    if (date === null || date === undefined || date === '')
        return '';
    const parsed = moment(date);
    if (!parsed.isValid())
        return '';
    return parsed.format('D MMM YYYY');
};
export const formatMDY = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('MM-DD-YYYY');
    return '';
};
export const formatYMD = (date) => {
    if (date !== null && date !== undefined)
        return moment(date).format('YYYY-MM-DD');
    return '';
};
export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = date
        .toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    })
        .replace(/\//g, '-');
    const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'short' }); // Get day of the week (e.g., Mon, Tue, etc.)
    return `${formattedDate} - ${dayOfWeek}`;
};
export const preventBackspaceAndDelete = (ref) => {
    const handleKeyDown = (event) => {
        if (typeof event.key === 'string' || event.key === 'Backspace' || event.key === 'Delete') {
            event.preventDefault();
            return;
        }
    };
    const datepickerElement = ref.current?.input;
    if (datepickerElement) {
        datepickerElement.addEventListener('keydown', handleKeyDown);
    }
    return () => {
        if (datepickerElement) {
            datepickerElement.removeEventListener('keydown', handleKeyDown);
        }
    };
};
